export default __webpack_public_path__ + "static/media/2.af54ad89.jpg";